"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BulkUpdateGoalsResponse", {
    enumerable: true,
    get: function() {
        return BulkUpdateGoalsResponse;
    }
});
const _zod = require("zod");
const BulkUpdateGoalsResponse = _zod.z.object({
    result: _zod.z.object({
        success: _zod.z.boolean()
    }).nullable()
});
